import React from 'react'

/** HealthyCoach logo mark: a blue rounded square with "HC" (matches components/brand/Logo). */
const BrandMark = ({ size = 26, className = '' }) => (
  <div
    className={`flex flex-none items-center justify-center bg-blue-600 font-semibold text-white ${className}`}
    style={{ width: size, height: size, borderRadius: Math.round(size * 0.27), fontSize: Math.round(size * 0.4) }}
    aria-hidden="true"
  >
    HC
  </div>
)

export default BrandMark
